import { render, staticRenderFns } from "./indexMadeInGermany.vue?vue&type=template&id=f51e3d12&scoped=true"
import script from "./indexMadeInGermany.vue?vue&type=script&lang=ts"
export * from "./indexMadeInGermany.vue?vue&type=script&lang=ts"
import style0 from "./indexMadeInGermany.vue?vue&type=style&index=0&id=f51e3d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51e3d12",
  null
  
)

export default component.exports